import React, { Fragment } from 'react';
import { ThemeProvider } from 'styled-components';
import { Helmet } from 'react-helmet';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/styles';

import PaginaPadrao from './containers/PaginaPadrao';
import GlobalStyle from './config/styles/global-styles';
import { Default, MuiTheme } from './config/themes';
import './helpers/dataLayer';

const App = () => {
    return (
        <ThemeProvider theme={Default}>
            <Fragment>
                <Helmet>
                    <meta charSet='utf-8' />
                    <link
                        rel='icon'
                        type='image/x-icon'
                        href='assets/favicon.ico'
                        sizes='16x16'
                    />
                </Helmet>
                <GlobalStyle />
                <MuiThemeProvider theme={MuiTheme}>
                    <PaginaPadrao />
                </MuiThemeProvider>
            </Fragment>
        </ThemeProvider>
    );
};
export default App;
